import { createSlice } from "@reduxjs/toolkit";
import { getAllCountries } from "./Helpers/getAllCountries";

import { getAllDosageForms } from "./Helpers/getAllDosageForms";


import { getAllRouteOfAdministration } from "./Helpers/getAllRouteOfAdministration";

import { getAllUnits } from "./Helpers/getAllUnits";
import { ReNotification } from "../../unity-ui-common/Components/ReNotification";
export type CountryTypes = {
  countryCode: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  alpha2: string;
  status: number;
};

export type DosageType = {
  createdAt: string;
  updatedAt: string;
  name: string;
  code: number;
  shortName: string;
  form: string;
  versionSEQ: number;
  status: number;
};


export type RouteOfAdministrationType = {
  createdAt: string;
  updatedAt: string;
  label: string;
  code: number;
  currentFlag: string;
  status: number;
};

export type UnitOfMeasurementType = {
  ucumCode: string;
  createdAt: string;
  updatedAt: string;
  label: string;
  currentFlag: string;
  status: number;
};




interface ContolledVocabulaiesState {
  allCountries: CountryTypes[];
  allDosageForm: DosageType[];
  allRouteOfAdministration: RouteOfAdministrationType[];
  allUnits: UnitOfMeasurementType[]
  loading: boolean;
  error: string;
  countryLoading: boolean;
  outcomeLoading: boolean,
  uomLoading: boolean,
  dosageLoading: boolean,
  routeAdministrationLoading: boolean
}

const initialState: ContolledVocabulaiesState = {
  allCountries: [],
  allDosageForm: [],
  allRouteOfAdministration: [],
  allUnits: [],
  loading: true,
  error: "",
  countryLoading: true,
  outcomeLoading: true,
  uomLoading: true,
  dosageLoading: true,
  routeAdministrationLoading: true
};

const ControlledVocabulariesSlice = createSlice({
  name: "controlledVocabularies",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(getAllCountries.pending, (state) => {
      state.countryLoading = true;
    });
    builder.addCase(getAllCountries.fulfilled, (state, action) => {
      state.allCountries = action.payload;
      state.countryLoading = false
    });
    builder.addCase(getAllCountries.rejected, (state, action) => {
      state.error = "Something went wrong";
      ReNotification({
        description: "Something went wrong",
        type: "error",
      });
      state.countryLoading = false
    });
    builder.addCase(getAllDosageForms.pending, (state) => {
      state.dosageLoading = true;
    });
    builder.addCase(getAllDosageForms.fulfilled, (state, action) => {
      state.allDosageForm = action.payload;
      state.dosageLoading = false
    });
    builder.addCase(getAllDosageForms.rejected, (state, action) => {
      state.error = "Something went wrong";
      ReNotification({
        description: "Something went wrong",
        type: "error",
      });
      state.dosageLoading = false
    });
    builder.addCase(getAllRouteOfAdministration.pending, (state) => {
      state.routeAdministrationLoading = true;
    });
    builder.addCase(getAllRouteOfAdministration.fulfilled, (state, action) => {
      state.allRouteOfAdministration = action.payload;
      state.routeAdministrationLoading = false
    });
    builder.addCase(getAllRouteOfAdministration.rejected, (state, action) => {
      state.error = "Something went wrong";
      ReNotification({
        description: "Something went wrong",
        type: "error",
      });
      state.routeAdministrationLoading = false
    });
    builder.addCase(getAllUnits.pending, (state) => {
      state.uomLoading = true;
    });
    builder.addCase(getAllUnits.fulfilled, (state, action) => {
      state.allUnits = action.payload;
      state.uomLoading = false
    });
    builder.addCase(getAllUnits.rejected, (state, action) => {
      state.error = "Something went wrong";
      ReNotification({
        description: "Something went wrong",
        type: "error",
      });
      state.uomLoading = false
    });
    
  },
});

export default ControlledVocabulariesSlice.reducer;
